import { render, staticRenderFns } from "./PrivacyPolicySummary.vue?vue&type=template&id=57378ceb&scoped=true"
import script from "./PrivacyPolicySummary.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicySummary.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicySummary.vue?vue&type=style&index=0&id=57378ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57378ceb",
  null
  
)

export default component.exports